import React, { useState } from 'react'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl, FormattedMessage } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({ existingUsageTasks }) => {
  const modal = useModal()
  const { formatMessage, formatDate } = useIntl()
  const [selectedTaskId, setSelectedTaskId] = useState(null)

  const handleConfirm = () => {
    if (!selectedTaskId) {
      return
    }

    modal.resolve({ baseTaskId: selectedTaskId })
    modal.remove()
  }

  const handleCancel = () => {
    modal.remove()
  }

  return (
    <Modal
      show={modal.visible}
      title={formatMessage(messages.title)}
      onClose={handleCancel}
      onOutsideClick={handleCancel}
      dialogPanelClasses="max-w-screen-sm"
    >
      <div className="space-y-2">
        {existingUsageTasks.map((task) => {
          const isSelected = selectedTaskId == task.uid
          const airingStart = task.airing_time_start
            ? formatDate(task.airing_time_start * 1000)
            : formatMessage(messages.notSet)
          const mediaText = task?.medias && !!task?.medias.length
            ? task?.medias.map(m => `${m.name} (${m.spot_count})`).join(', ')
            : formatMessage(messages.notSet)
          const territoryMarketText = task?.territoryMarkets && !!task?.territoryMarkets.length
            ? task?.territoryMarkets.map(tm => tm.name).join(', ')
            : formatMessage(messages.notSet)
          const airingTimeText = task?.usage && task?.usage?.name
            ? task?.usage?.name
            : formatMessage(messages.notSet)
          const supplierText = task?.supplier && task?.supplier?.userid
            ? task?.supplier?.userid
            : formatMessage(messages.noSupplier)

          return (
            <div
              key={task.uid}
              onClick={() => setSelectedTaskId(task.uid)}
              className={`
                p-4 border-2 rounded-lg cursor-pointer transition-colors flex gap-2 justify-between
                ${isSelected
                  ? 'border-primary'
                  : 'border-gray-200 hover:border-gray-300'
                }
              `}
            >
              <div>
                <div className="font-semibold">
                  { `#${task.uid} ${supplierText}`}
                </div>
                <div className="items-center">
                  <div>
                    <div className="text-sm text-gray-600">
                      <FormattedMessage {...messages.started} />: {airingStart}
                    </div>
                    <div className="text-sm text-gray-600">
                      <FormattedMessage {...messages.airingTime} />: {airingTimeText}
                    </div>
                    <div className="text-sm text-gray-600">
                      <FormattedMessage {...messages.media} />: {mediaText}
                    </div>
                    <div className="text-sm text-gray-600">
                      <FormattedMessage {...messages.territoryMarket} />: {territoryMarketText}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
        <div className='w-full text-right'>
          <Button
            size="sm"
            disabled={!selectedTaskId}
            onClick={handleConfirm}
          >
            {formatMessage(messages.confirm)}
          </Button>
        </div>
      </div>
    </Modal>
  )
})
